/* tslint:disable */
/* eslint-disable */
/**
 * Thynk Direct API
 * The API for managing reservation for [Thynk Direct](https://thynk.cloud/).
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base';
// @ts-ignore
import { LocationRoomTypeRead } from '../model';
// @ts-ignore
import { LocationRoomTypeWrite } from '../model';
// @ts-ignore
import { LocationRoomTypesGetCollection200Response } from '../model';
// @ts-ignore
import { LocationRoomTypesavailabilitiesGetCollection200Response } from '../model';
/**
 * LocationRoomTypeApi - axios parameter creator
 * @export
 */
export const LocationRoomTypeApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Retrieves the collection of LocationRoomType resources.
     * @summary Retrieves the collection of LocationRoomType resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {string} [location]
     * @param {Array<string>} [location2]
     * @param {string} [code]
     * @param {Array<string>} [code2]
     * @param {string} [search]
     * @param {LocationRoomTypesGetCollectionOrderCodeEnum} [orderCode]
     * @param {LocationRoomTypesGetCollectionOrderRoomsTypeEnum} [orderRoomsType]
     * @param {LocationRoomTypesGetCollectionOrderLocationNameEnum} [orderLocationName]
     * @param {LocationRoomTypesGetCollectionOrderTranslationsNameEnum} [orderTranslationsName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationRoomTypesGetCollection: async (
      page?: number,
      itemsPerPage?: number,
      location?: string,
      location2?: Array<string>,
      code?: string,
      code2?: Array<string>,
      search?: string,
      orderCode?: LocationRoomTypesGetCollectionOrderCodeEnum,
      orderRoomsType?: LocationRoomTypesGetCollectionOrderRoomsTypeEnum,
      orderLocationName?: LocationRoomTypesGetCollectionOrderLocationNameEnum,
      orderTranslationsName?: LocationRoomTypesGetCollectionOrderTranslationsNameEnum,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/location_room_types`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (itemsPerPage !== undefined) {
        localVarQueryParameter['itemsPerPage'] = itemsPerPage;
      }

      if (location !== undefined) {
        localVarQueryParameter['location'] = location;
      }

      if (location2) {
        localVarQueryParameter['location[]'] = location2;
      }

      if (code !== undefined) {
        localVarQueryParameter['code'] = code;
      }

      if (code2) {
        localVarQueryParameter['code[]'] = code2;
      }

      if (search !== undefined) {
        localVarQueryParameter['search'] = search;
      }

      if (orderCode !== undefined) {
        localVarQueryParameter['order[code]'] = orderCode;
      }

      if (orderRoomsType !== undefined) {
        localVarQueryParameter['order[rooms.type]'] = orderRoomsType;
      }

      if (orderLocationName !== undefined) {
        localVarQueryParameter['order[location.name]'] = orderLocationName;
      }

      if (orderTranslationsName !== undefined) {
        localVarQueryParameter['order[translations.name]'] =
          orderTranslationsName;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves a LocationRoomType resource.
     * @summary Retrieves a LocationRoomType resource.
     * @param {string} id LocationRoomType identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationRoomTypesIdGet: async (
      id: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('locationRoomTypesIdGet', 'id', id);
      const localVarPath = `/api/location_room_types/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Updates the LocationRoomType resource.
     * @summary Updates the LocationRoomType resource.
     * @param {string} id LocationRoomType identifier
     * @param {LocationRoomTypeWrite} locationRoomTypeWrite The updated LocationRoomType resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationRoomTypesIdPatch: async (
      id: string,
      locationRoomTypeWrite: LocationRoomTypeWrite,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('locationRoomTypesIdPatch', 'id', id);
      // verify required parameter 'locationRoomTypeWrite' is not null or undefined
      assertParamExists(
        'locationRoomTypesIdPatch',
        'locationRoomTypeWrite',
        locationRoomTypeWrite,
      );
      const localVarPath = `/api/location_room_types/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        locationRoomTypeWrite,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Replaces the LocationRoomType resource.
     * @summary Replaces the LocationRoomType resource.
     * @param {string} id LocationRoomType identifier
     * @param {LocationRoomTypeWrite} locationRoomTypeWrite The updated LocationRoomType resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationRoomTypesIdPut: async (
      id: string,
      locationRoomTypeWrite: LocationRoomTypeWrite,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('locationRoomTypesIdPut', 'id', id);
      // verify required parameter 'locationRoomTypeWrite' is not null or undefined
      assertParamExists(
        'locationRoomTypesIdPut',
        'locationRoomTypeWrite',
        locationRoomTypeWrite,
      );
      const localVarPath = `/api/location_room_types/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/ld+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        locationRoomTypeWrite,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves the collection of RoomAvailabilities resources.
     * @summary Retrieve room types availabilities.
     * @param {string} [arrivalDate] Checkin date at the hotel
     * @param {string} [departureDate] Checkout date at the hotel
     * @param {number} [amount] Amount of the hotels rooms booked
     * @param {number} [locationId] Filter room types by location
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationRoomTypesavailabilitiesGetCollection: async (
      arrivalDate?: string,
      departureDate?: string,
      amount?: number,
      locationId?: number,
      page?: number,
      itemsPerPage?: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/location_room_types/availabilities`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (arrivalDate !== undefined) {
        localVarQueryParameter['arrivalDate'] =
          (arrivalDate as any) instanceof Date
            ? (arrivalDate as any).toISOString().substring(0, 10)
            : arrivalDate;
      }

      if (departureDate !== undefined) {
        localVarQueryParameter['departureDate'] =
          (departureDate as any) instanceof Date
            ? (departureDate as any).toISOString().substring(0, 10)
            : departureDate;
      }

      if (amount !== undefined) {
        localVarQueryParameter['amount'] = amount;
      }

      if (locationId !== undefined) {
        localVarQueryParameter['locationId'] = locationId;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (itemsPerPage !== undefined) {
        localVarQueryParameter['itemsPerPage'] = itemsPerPage;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * LocationRoomTypeApi - functional programming interface
 * @export
 */
export const LocationRoomTypeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    LocationRoomTypeApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieves the collection of LocationRoomType resources.
     * @summary Retrieves the collection of LocationRoomType resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {string} [location]
     * @param {Array<string>} [location2]
     * @param {string} [code]
     * @param {Array<string>} [code2]
     * @param {string} [search]
     * @param {LocationRoomTypesGetCollectionOrderCodeEnum} [orderCode]
     * @param {LocationRoomTypesGetCollectionOrderRoomsTypeEnum} [orderRoomsType]
     * @param {LocationRoomTypesGetCollectionOrderLocationNameEnum} [orderLocationName]
     * @param {LocationRoomTypesGetCollectionOrderTranslationsNameEnum} [orderTranslationsName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async locationRoomTypesGetCollection(
      page?: number,
      itemsPerPage?: number,
      location?: string,
      location2?: Array<string>,
      code?: string,
      code2?: Array<string>,
      search?: string,
      orderCode?: LocationRoomTypesGetCollectionOrderCodeEnum,
      orderRoomsType?: LocationRoomTypesGetCollectionOrderRoomsTypeEnum,
      orderLocationName?: LocationRoomTypesGetCollectionOrderLocationNameEnum,
      orderTranslationsName?: LocationRoomTypesGetCollectionOrderTranslationsNameEnum,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LocationRoomTypesGetCollection200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.locationRoomTypesGetCollection(
          page,
          itemsPerPage,
          location,
          location2,
          code,
          code2,
          search,
          orderCode,
          orderRoomsType,
          orderLocationName,
          orderTranslationsName,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'LocationRoomTypeApi.locationRoomTypesGetCollection'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Retrieves a LocationRoomType resource.
     * @summary Retrieves a LocationRoomType resource.
     * @param {string} id LocationRoomType identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async locationRoomTypesIdGet(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LocationRoomTypeRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.locationRoomTypesIdGet(id, options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['LocationRoomTypeApi.locationRoomTypesIdGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Updates the LocationRoomType resource.
     * @summary Updates the LocationRoomType resource.
     * @param {string} id LocationRoomType identifier
     * @param {LocationRoomTypeWrite} locationRoomTypeWrite The updated LocationRoomType resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async locationRoomTypesIdPatch(
      id: string,
      locationRoomTypeWrite: LocationRoomTypeWrite,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LocationRoomTypeRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.locationRoomTypesIdPatch(
          id,
          locationRoomTypeWrite,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['LocationRoomTypeApi.locationRoomTypesIdPatch']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Replaces the LocationRoomType resource.
     * @summary Replaces the LocationRoomType resource.
     * @param {string} id LocationRoomType identifier
     * @param {LocationRoomTypeWrite} locationRoomTypeWrite The updated LocationRoomType resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async locationRoomTypesIdPut(
      id: string,
      locationRoomTypeWrite: LocationRoomTypeWrite,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LocationRoomTypeRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.locationRoomTypesIdPut(
          id,
          locationRoomTypeWrite,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['LocationRoomTypeApi.locationRoomTypesIdPut']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Retrieves the collection of RoomAvailabilities resources.
     * @summary Retrieve room types availabilities.
     * @param {string} [arrivalDate] Checkin date at the hotel
     * @param {string} [departureDate] Checkout date at the hotel
     * @param {number} [amount] Amount of the hotels rooms booked
     * @param {number} [locationId] Filter room types by location
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async locationRoomTypesavailabilitiesGetCollection(
      arrivalDate?: string,
      departureDate?: string,
      amount?: number,
      locationId?: number,
      page?: number,
      itemsPerPage?: number,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LocationRoomTypesavailabilitiesGetCollection200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.locationRoomTypesavailabilitiesGetCollection(
          arrivalDate,
          departureDate,
          amount,
          locationId,
          page,
          itemsPerPage,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'LocationRoomTypeApi.locationRoomTypesavailabilitiesGetCollection'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * LocationRoomTypeApi - factory interface
 * @export
 */
export const LocationRoomTypeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = LocationRoomTypeApiFp(configuration);
  return {
    /**
     * Retrieves the collection of LocationRoomType resources.
     * @summary Retrieves the collection of LocationRoomType resources.
     * @param {LocationRoomTypeApiLocationRoomTypesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationRoomTypesGetCollection(
      requestParameters: LocationRoomTypeApiLocationRoomTypesGetCollectionRequest = {},
      options?: AxiosRequestConfig,
    ): AxiosPromise<LocationRoomTypesGetCollection200Response> {
      return localVarFp
        .locationRoomTypesGetCollection(
          requestParameters.page,
          requestParameters.itemsPerPage,
          requestParameters.location,
          requestParameters.location2,
          requestParameters.code,
          requestParameters.code2,
          requestParameters.search,
          requestParameters.orderCode,
          requestParameters.orderRoomsType,
          requestParameters.orderLocationName,
          requestParameters.orderTranslationsName,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves a LocationRoomType resource.
     * @summary Retrieves a LocationRoomType resource.
     * @param {LocationRoomTypeApiLocationRoomTypesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationRoomTypesIdGet(
      requestParameters: LocationRoomTypeApiLocationRoomTypesIdGetRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<LocationRoomTypeRead> {
      return localVarFp
        .locationRoomTypesIdGet(requestParameters.id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Updates the LocationRoomType resource.
     * @summary Updates the LocationRoomType resource.
     * @param {LocationRoomTypeApiLocationRoomTypesIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationRoomTypesIdPatch(
      requestParameters: LocationRoomTypeApiLocationRoomTypesIdPatchRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<LocationRoomTypeRead> {
      return localVarFp
        .locationRoomTypesIdPatch(
          requestParameters.id,
          requestParameters.locationRoomTypeWrite,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Replaces the LocationRoomType resource.
     * @summary Replaces the LocationRoomType resource.
     * @param {LocationRoomTypeApiLocationRoomTypesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationRoomTypesIdPut(
      requestParameters: LocationRoomTypeApiLocationRoomTypesIdPutRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<LocationRoomTypeRead> {
      return localVarFp
        .locationRoomTypesIdPut(
          requestParameters.id,
          requestParameters.locationRoomTypeWrite,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves the collection of RoomAvailabilities resources.
     * @summary Retrieve room types availabilities.
     * @param {LocationRoomTypeApiLocationRoomTypesavailabilitiesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationRoomTypesavailabilitiesGetCollection(
      requestParameters: LocationRoomTypeApiLocationRoomTypesavailabilitiesGetCollectionRequest = {},
      options?: AxiosRequestConfig,
    ): AxiosPromise<LocationRoomTypesavailabilitiesGetCollection200Response> {
      return localVarFp
        .locationRoomTypesavailabilitiesGetCollection(
          requestParameters.arrivalDate,
          requestParameters.departureDate,
          requestParameters.amount,
          requestParameters.locationId,
          requestParameters.page,
          requestParameters.itemsPerPage,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for locationRoomTypesGetCollection operation in LocationRoomTypeApi.
 * @export
 * @interface LocationRoomTypeApiLocationRoomTypesGetCollectionRequest
 */
export interface LocationRoomTypeApiLocationRoomTypesGetCollectionRequest {
  /**
   * The collection page number
   * @type {number}
   * @memberof LocationRoomTypeApiLocationRoomTypesGetCollection
   */
  readonly page?: number;

  /**
   * The number of items per page
   * @type {number}
   * @memberof LocationRoomTypeApiLocationRoomTypesGetCollection
   */
  readonly itemsPerPage?: number;

  /**
   *
   * @type {string}
   * @memberof LocationRoomTypeApiLocationRoomTypesGetCollection
   */
  readonly location?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof LocationRoomTypeApiLocationRoomTypesGetCollection
   */
  readonly location2?: Array<string>;

  /**
   *
   * @type {string}
   * @memberof LocationRoomTypeApiLocationRoomTypesGetCollection
   */
  readonly code?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof LocationRoomTypeApiLocationRoomTypesGetCollection
   */
  readonly code2?: Array<string>;

  /**
   *
   * @type {string}
   * @memberof LocationRoomTypeApiLocationRoomTypesGetCollection
   */
  readonly search?: string;

  /**
   *
   * @type {'asc' | 'desc'}
   * @memberof LocationRoomTypeApiLocationRoomTypesGetCollection
   */
  readonly orderCode?: LocationRoomTypesGetCollectionOrderCodeEnum;

  /**
   *
   * @type {'asc' | 'desc'}
   * @memberof LocationRoomTypeApiLocationRoomTypesGetCollection
   */
  readonly orderRoomsType?: LocationRoomTypesGetCollectionOrderRoomsTypeEnum;

  /**
   *
   * @type {'asc' | 'desc'}
   * @memberof LocationRoomTypeApiLocationRoomTypesGetCollection
   */
  readonly orderLocationName?: LocationRoomTypesGetCollectionOrderLocationNameEnum;

  /**
   *
   * @type {'asc' | 'desc'}
   * @memberof LocationRoomTypeApiLocationRoomTypesGetCollection
   */
  readonly orderTranslationsName?: LocationRoomTypesGetCollectionOrderTranslationsNameEnum;
}

/**
 * Request parameters for locationRoomTypesIdGet operation in LocationRoomTypeApi.
 * @export
 * @interface LocationRoomTypeApiLocationRoomTypesIdGetRequest
 */
export interface LocationRoomTypeApiLocationRoomTypesIdGetRequest {
  /**
   * LocationRoomType identifier
   * @type {string}
   * @memberof LocationRoomTypeApiLocationRoomTypesIdGet
   */
  readonly id: string;
}

/**
 * Request parameters for locationRoomTypesIdPatch operation in LocationRoomTypeApi.
 * @export
 * @interface LocationRoomTypeApiLocationRoomTypesIdPatchRequest
 */
export interface LocationRoomTypeApiLocationRoomTypesIdPatchRequest {
  /**
   * LocationRoomType identifier
   * @type {string}
   * @memberof LocationRoomTypeApiLocationRoomTypesIdPatch
   */
  readonly id: string;

  /**
   * The updated LocationRoomType resource
   * @type {LocationRoomTypeWrite}
   * @memberof LocationRoomTypeApiLocationRoomTypesIdPatch
   */
  readonly locationRoomTypeWrite: LocationRoomTypeWrite;
}

/**
 * Request parameters for locationRoomTypesIdPut operation in LocationRoomTypeApi.
 * @export
 * @interface LocationRoomTypeApiLocationRoomTypesIdPutRequest
 */
export interface LocationRoomTypeApiLocationRoomTypesIdPutRequest {
  /**
   * LocationRoomType identifier
   * @type {string}
   * @memberof LocationRoomTypeApiLocationRoomTypesIdPut
   */
  readonly id: string;

  /**
   * The updated LocationRoomType resource
   * @type {LocationRoomTypeWrite}
   * @memberof LocationRoomTypeApiLocationRoomTypesIdPut
   */
  readonly locationRoomTypeWrite: LocationRoomTypeWrite;
}

/**
 * Request parameters for locationRoomTypesavailabilitiesGetCollection operation in LocationRoomTypeApi.
 * @export
 * @interface LocationRoomTypeApiLocationRoomTypesavailabilitiesGetCollectionRequest
 */
export interface LocationRoomTypeApiLocationRoomTypesavailabilitiesGetCollectionRequest {
  /**
   * Checkin date at the hotel
   * @type {string}
   * @memberof LocationRoomTypeApiLocationRoomTypesavailabilitiesGetCollection
   */
  readonly arrivalDate?: string;

  /**
   * Checkout date at the hotel
   * @type {string}
   * @memberof LocationRoomTypeApiLocationRoomTypesavailabilitiesGetCollection
   */
  readonly departureDate?: string;

  /**
   * Amount of the hotels rooms booked
   * @type {number}
   * @memberof LocationRoomTypeApiLocationRoomTypesavailabilitiesGetCollection
   */
  readonly amount?: number;

  /**
   * Filter room types by location
   * @type {number}
   * @memberof LocationRoomTypeApiLocationRoomTypesavailabilitiesGetCollection
   */
  readonly locationId?: number;

  /**
   * The collection page number
   * @type {number}
   * @memberof LocationRoomTypeApiLocationRoomTypesavailabilitiesGetCollection
   */
  readonly page?: number;

  /**
   * The number of items per page
   * @type {number}
   * @memberof LocationRoomTypeApiLocationRoomTypesavailabilitiesGetCollection
   */
  readonly itemsPerPage?: number;
}

/**
 * LocationRoomTypeApi - object-oriented interface
 * @export
 * @class LocationRoomTypeApi
 * @extends {BaseAPI}
 */
export class LocationRoomTypeApi extends BaseAPI {
  /**
   * Retrieves the collection of LocationRoomType resources.
   * @summary Retrieves the collection of LocationRoomType resources.
   * @param {LocationRoomTypeApiLocationRoomTypesGetCollectionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LocationRoomTypeApi
   */
  public locationRoomTypesGetCollection(
    requestParameters: LocationRoomTypeApiLocationRoomTypesGetCollectionRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return LocationRoomTypeApiFp(this.configuration)
      .locationRoomTypesGetCollection(
        requestParameters.page,
        requestParameters.itemsPerPage,
        requestParameters.location,
        requestParameters.location2,
        requestParameters.code,
        requestParameters.code2,
        requestParameters.search,
        requestParameters.orderCode,
        requestParameters.orderRoomsType,
        requestParameters.orderLocationName,
        requestParameters.orderTranslationsName,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves a LocationRoomType resource.
   * @summary Retrieves a LocationRoomType resource.
   * @param {LocationRoomTypeApiLocationRoomTypesIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LocationRoomTypeApi
   */
  public locationRoomTypesIdGet(
    requestParameters: LocationRoomTypeApiLocationRoomTypesIdGetRequest,
    options?: AxiosRequestConfig,
  ) {
    return LocationRoomTypeApiFp(this.configuration)
      .locationRoomTypesIdGet(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Updates the LocationRoomType resource.
   * @summary Updates the LocationRoomType resource.
   * @param {LocationRoomTypeApiLocationRoomTypesIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LocationRoomTypeApi
   */
  public locationRoomTypesIdPatch(
    requestParameters: LocationRoomTypeApiLocationRoomTypesIdPatchRequest,
    options?: AxiosRequestConfig,
  ) {
    return LocationRoomTypeApiFp(this.configuration)
      .locationRoomTypesIdPatch(
        requestParameters.id,
        requestParameters.locationRoomTypeWrite,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Replaces the LocationRoomType resource.
   * @summary Replaces the LocationRoomType resource.
   * @param {LocationRoomTypeApiLocationRoomTypesIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LocationRoomTypeApi
   */
  public locationRoomTypesIdPut(
    requestParameters: LocationRoomTypeApiLocationRoomTypesIdPutRequest,
    options?: AxiosRequestConfig,
  ) {
    return LocationRoomTypeApiFp(this.configuration)
      .locationRoomTypesIdPut(
        requestParameters.id,
        requestParameters.locationRoomTypeWrite,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves the collection of RoomAvailabilities resources.
   * @summary Retrieve room types availabilities.
   * @param {LocationRoomTypeApiLocationRoomTypesavailabilitiesGetCollectionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LocationRoomTypeApi
   */
  public locationRoomTypesavailabilitiesGetCollection(
    requestParameters: LocationRoomTypeApiLocationRoomTypesavailabilitiesGetCollectionRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return LocationRoomTypeApiFp(this.configuration)
      .locationRoomTypesavailabilitiesGetCollection(
        requestParameters.arrivalDate,
        requestParameters.departureDate,
        requestParameters.amount,
        requestParameters.locationId,
        requestParameters.page,
        requestParameters.itemsPerPage,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const LocationRoomTypesGetCollectionOrderCodeEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type LocationRoomTypesGetCollectionOrderCodeEnum =
  (typeof LocationRoomTypesGetCollectionOrderCodeEnum)[keyof typeof LocationRoomTypesGetCollectionOrderCodeEnum];
/**
 * @export
 */
export const LocationRoomTypesGetCollectionOrderRoomsTypeEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type LocationRoomTypesGetCollectionOrderRoomsTypeEnum =
  (typeof LocationRoomTypesGetCollectionOrderRoomsTypeEnum)[keyof typeof LocationRoomTypesGetCollectionOrderRoomsTypeEnum];
/**
 * @export
 */
export const LocationRoomTypesGetCollectionOrderLocationNameEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type LocationRoomTypesGetCollectionOrderLocationNameEnum =
  (typeof LocationRoomTypesGetCollectionOrderLocationNameEnum)[keyof typeof LocationRoomTypesGetCollectionOrderLocationNameEnum];
/**
 * @export
 */
export const LocationRoomTypesGetCollectionOrderTranslationsNameEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type LocationRoomTypesGetCollectionOrderTranslationsNameEnum =
  (typeof LocationRoomTypesGetCollectionOrderTranslationsNameEnum)[keyof typeof LocationRoomTypesGetCollectionOrderTranslationsNameEnum];
